<app-data-grid-comp
    [columns]="columns"
    [bindingType]="bindingType"
    [view]="view"
    [gridData]="gridData"
    [gridDataResult]="gridDataResult"
    [isLoading]="isLoading"
    [pageSize]="pageSize"
    [skip]="skip"
    category="Disciplines"
    [isLoading]="isLoading"
    (emitPageChangeEvent)="pageChange($event)"
    (emitOpenDialogEvent)="openEmploymentRecordDisciplineDialog($event)"
    (emitDeleteEvent)="deleteEmploymentRecordBenefit($event)"
></app-data-grid-comp>